const INVALID_FOLDER_SEGMENT = /[/\\]|\.\./;

export const normalizeExplorerRelativePath = (relativePath: string): string => relativePath.replace(/^\/+|\/+$/g, "");

export const sanitizeFolderName = (raw: string): string | null => {
  const trimmed = raw.trim();
  if (!trimmed || INVALID_FOLDER_SEGMENT.test(trimmed) || trimmed === ".keep") {
    return null;
  }

  return trimmed;
};

export const formatFileSize = (sizeBytes: number): string => {
  if (sizeBytes < 1024) {
    return `${String(sizeBytes)} B`;
  }

  if (sizeBytes < 1024 * 1024) {
    return `${(sizeBytes / 1024).toFixed(1)} KB`;
  }

  return `${(sizeBytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const formatUpdatedAt = (updatedAt: Date): string =>
  updatedAt.toLocaleString("de-DE", {
    dateStyle: "medium",
    timeStyle: "short",
  });

export const getBreadcrumbSegments = (currentPath: string): { label: string; path: string }[] => {
  const segments = [{ label: "web/downloads", path: "" }];

  if (!currentPath) {
    return segments;
  }

  const parts = currentPath.split("/").filter(Boolean);
  let accumulatedPath = "";

  for (const part of parts) {
    accumulatedPath = accumulatedPath ? `${accumulatedPath}/${part}` : part;
    segments.push({ label: part, path: accumulatedPath });
  }

  return segments;
};
